import { Occupation } from 'generated/types'

export const formatEmploymentStatusList = (originalList: string[]) => {
  return originalList.map(employmentStatus => ({
    label: employmentStatus,
    value: employmentStatus,
  }))
}

export const filterNFormatOccupationList = (originalList: Occupation[], filterList: string[]) => {
  return originalList.reduce<{ label: string; value: string }[]>(
    (formattedFilteredList, { name }) => {
      if (!filterList.includes(name)) {
        formattedFilteredList.push({ label: name, value: name })
      }
      return formattedFilteredList
    },
    [],
  )
}
